// _constants
// @todo  enums where applicable
// slides, scroll
export const SLIDES_SELECTOR = '[data-decade][data-year]';
// colours
// here for now
export const COLOURS = {
    GREEN_10: '#F2FFD8',
    GREY_10: '#DDD',
    GREY_20: '#595959',
    GREY_30: '#ABABAB',
    RED_10: '#DC2440',
    WHITE_10: '#FFF',
};
// desktop
export const DESKTOP_ELEMS = {
    OPEN: '.open',
    DECADES: {
        EN: 's',
        FR: 'a.',
    },
    CONTENT: '#content',
};
// mobile
export const MOBILE_ELEMS = {
    CONT_PARENT: '#tlMobileContainerParent',
    CONTAINER: '#tlMobileContainer',
    HIGHLIGHT: '.highlight-year',
    HL_PREFIX: 'hl-',
    DRAG_PREFIX: 'dr-fill-',
    YEARS: '.mobileYear',
    ARROW_LEFT: '.leftArrow',
    ARROW_RIGHT: '.rightArrow',
    MIDDLE_YEAR: '.highlightYearYear',
};
export const MOBILE_SCROLL = {
    VISIBLE_YRS: 5,
    DISTANCE: 5,
    DISTANCE_MIN: 5,
    SPEED: 5,
    INTERVAL: 5,
    DIR_PREV: 'previous',
    DIR_NEXT: 'next',
};
